<template>
  <ModalComponent
    name="approveApprovalModal"
    width="500"
    height="auto"
    :adaptive="true"
    :click-to-close="true"
    @before-close="modalClosed"
  >
    <div class="flex flex-col justify-between px-5 py-3">
      <div class="flex justify-between">
        <h2
          class="flex items-center gap-x-1.5 text-xl font-semibold text-gray-900 lg:text-lg"
        >
          <span>Confirmation required</span>
        </h2>
        <button
          class="flex h-8 w-8 items-center justify-center rounded-md bg-[#EEEFF0D4] text-[#808080] outline-none"
          @click="$modal.hide('approveApprovalModal')"
        >
          <TimesSmall />
        </button>
      </div>
      <div class="flex h-16 items-start">
        <p class="text-sm">
          Are you sure you want to approve this submission?
        </p>
      </div>
      <div class="flex justify-end gap-2 border-t-2 pt-2">
        <GhostButton @click="closeModal">
          Cancel
        </GhostButton>
        <PrimaryButton @click="submitButtonClicked">
          Yes, continue
        </PrimaryButton>
      </div>
    </div>
  </ModalComponent>
</template>

<script>
export default {
  name: 'ApproveApprovalModal',

  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
  },

  emits: ['submit', 'modal-closed'],

  watch: {
    isOpen(val) {
      if (val) {
        this.$modal.show('approveApprovalModal')
      }
    },
  },

  methods: {
    submitButtonClicked() {
      this.$emit('submit', this.rejectMessage)
      this.$modal.hide('approveApprovalModal')
    },
    closeModal() {
      this.$modal.hide('approveApprovalModal')
    },
    modalClosed() {
      this.$emit('modal-closed')
    },
  },
}
</script>
